import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const OutageBanner = () => import(/* webpackChunkName: "4-feat-outage-banner" */ './OutageBanner');

const LoadableOutageBanner = lazyLoadOnRender({ loader: OutageBanner });
export default LoadableOutageBanner;
